module.exports = __webpack_public_path__ + "content/algorithm.a6795dd9.worker.js"